import { Brand } from '@/config/brand.config';
import { Variant } from '@/types';

const getSearchHistory = (brand: Brand): string[] => {
  const storedSearchHistory = localStorage.getItem(`${brand}-search-history`);
  return storedSearchHistory ? JSON.parse(storedSearchHistory) : [];
};

const getVariantHistory = (brand: Brand): Variant[] => {
  const storedVariantHistory = localStorage.getItem(`${brand}-variant-history`);
  return storedVariantHistory ? JSON.parse(storedVariantHistory) : [];
};

const updateSearchHistory = (searchString: string, brand: Brand) => {
  if (!searchString) return;
  const currentSearchHistory = getSearchHistory(brand).filter((searchHistory) => searchHistory !== searchString);
  const updatedSearchHistory = [searchString, ...currentSearchHistory].slice(0, 10);

  localStorage.setItem(`${brand}-search-history`, JSON.stringify(updatedSearchHistory));
};

const updateVariantHistory = (variant: Variant, brand: Brand) => {
  if (!variant.name && !variant.variantSlug) return;
  const currentVariantHistory = getVariantHistory(brand).filter(
    (variantHistory) => variantHistory.variantSlug !== variant.variantSlug,
  );
  const updatedVariantHistory = [
    {
      articleNumber: variant.articleNumber,
      name: variant.name,
      brands: variant.brands,
      variantSlug: variant.variantSlug,
    },
    ...currentVariantHistory,
  ].slice(0, 10);

  localStorage.setItem(`${brand}-variant-history`, JSON.stringify(updatedVariantHistory));
};

export { getSearchHistory, updateSearchHistory, getVariantHistory, updateVariantHistory };
